// extracted by mini-css-extract-plugin
export default {"optionContainer":"styles_optionContainer__d2FRo","option":"styles_option__42qDG","selected":"styles_selected__N+eHY"};